export default __webpack_public_path__ + "dim-d08d72.json";